module.exports = __webpack_public_path__ + "static/img/img-cp2-1.10de47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp2-1.png
// module id = /8dK
// module chunks = 0